import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import DocumentEntryEdit from "./pages/DocManagement/DocumentEntry/DocumentEntryEdit";
import DocFiles from "./pages/DocManagement/DocFiles/DocFiles";
import DocManagerReports from "./pages/reports/DocManagerReports/DocManagerReports";

const storedLanguage = localStorage.getItem("preferredLanguage");

const resources = {
  en: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        zoneMaster: "Zone Master",
        add: "ADD",
        Add: "ADD",
        print: "PRINT",
        Print: "Print",
        Active: "Active",
        InActive: "InActive",
        Action: "Action",
        SrNo: "Sr No.",
        zoneName: "Zone Name",
        zoneCode: "Zone Code",
        Status: "Status",
        search: "Search",
        save: "Save",
        reset: "Reset",
        createZoneMaster: "Create Zone Master",
        editZoneMaster: "Edit Zone Master",
        enterZoneName: "Enter Zone Name",
        enterZoneCode: "Enter Zone Code",
        req: "Enter Zone Name required",
        update: "Update",
        wardMaster: "Ward Master",
        wardName: "Ward Name",
        wardCode: "Ward code",
        createWardMaster: "Create Ward Master",
        editWardMaster: "Edit Ward Master",
        enterWardName: "Enter Ward Name",
        enterWardCode: "Enter Ward Code",
        req1: "Enter Ward Name required",
        SelectZoneName: "Select Zone Name ",
        reqSelectZoneName: "Select Zone Name is required",
        CategoryMaster: "Category Master",
        CategoryName: "Category Name",
        EnterCategoryName: "Enter Category Name",
        CreateCategoryMaster: "Create Category Master",
        reqCategory: "Enter Category Name required",
        EditCategoryMaster: "Edit Category Master",
        SubCategoryMaster: "Sub Category Master",
        SubCategoryName: "Sub Category Name",
        RemarkName: "Remark",
        CreateSubCategoryMaster: "Create Sub Category Master",
        EnterSubCategoryName: "Enter Sub Category Name",
        EnterCategoryRemark: "Enter Category Remark",
        reqSelectCategory: "Select Category Required",
        reqEnterSubCategory: "Sub Category Required",
        SelectCategory: "Select Category ",
        EditSubCategoryMaster: "Edit Sub Category Master",
        AdvertiseLocationMaster: "Advertisement Location Master",
        AdvertiseArea: "Advertise Area",
        NearestLocation: "Nearest Location",
        NoOfSites: "No Of Sites",
        latitute: "Latitute",
        longitude: "Longitude",
        CreateAdvertiseLocationMaster: "Create Advertisement Location Master",
        EnterLandmark: "Enter Landmark",
        AttachAdvertiseLocationImage: "Attach Advertisement Location Image",
        selectZone: "Select Zone",
        EditAdvertiseLocationMaster: "Edit Advertisement Location Master",
        FinancialCalendarMaster: "Financial Calendar Master",
        FinancialYear: "Financial Year",
        FromDate: "From Date",
        Todate: "To date",
        CreateFinancialCalendarMaster: "Create Financial Calendar Master",
        ReqEnterFinancialYear: "*Required Enter Financial Year",
        ReqEnterFromDate: "*Required Enter From Date",
        RequiredEnterToDate: "*Required Enter To Date",
        EditFinancialCalendarMaster: "Edit Financial Calendar Master",
        AdvertisementTypeMaster: "Advertisement Type Master",
        AdvertisementName: "Adv. Name",
        rateIsFixed: "Rate Fixed",
        rateType: "Rate Type",
        DayWise: "Day Wise",
        MonthWise: "Month Wise",
        YearWise: "Year Wise",
        createAdvertisementTypeMaster: "Create Advertisement Type Master",
        enterAdvertisementTypeName: "Enter Advertisement Type Name",
        EditAdvertisementTypeMaster: "Edit Advertisement Type Master",
        AdvertisementSubTypeMaster: "Advertisement Sub Type Master",
        SubAdvertisementName: "Sub Adv. Name",
        Description: "Description",
        MaxLength: "Length",
        MaxWidth: "Width",
        MaxHeight: "Height",
        AreaSquareMeter: "Area Sq Mtrs",
        ratePerSqMtr: "Rate/SqMtr",
        Amount: "Amount",
        Premium: "Premium",
        BasePrice: "Base Price",
        CreateSubAdvertisementTypeMaster:
          "Create Sub Advertisement Type Master",
        reqAdvertismentTypeName:
          "Enter Advertisement Type Name should be required",
        EnterSubAdvertisementName: "Enter Sub Advertisement Name",
        EnterDescription: "Enter Description",
        EnterMaxLength: "Enter Max Length (in feet)",
        EnterMaxWidth: "Enter Max Width (in feet)",
        EnterMaxHeight: "Enter Max Height (in feet)",
        EnterAreaSquareMeter: "Enter Area Square Meter",
        EnterRatePerSquareMeter: "Enter Rate Per Square Meter",
        EnterAmount: "Enter Amount",
        EnterPremium: "Enter Premium",
        EnterBasePrice: "Enter Base Price",
        EditSubAdvertisementTypeMaster: "Edit Sub Advertisement Type Master",
        TaxMaster: "Tax Master",
        TaxName: "Tax Name",
        TaxPercentage: "Tax Percentage",
        EffectiveDate: "Effective Date",
        CreateTaxMaster: "Create Tax Master",
        EnterTaxName: "Enter Tax Name",
        EnterTaxPercentage: "Enter Tax Percentage",
        EnterEffectiveDate: "Enter Effective Date",
        reqTaxPercentage: "Tax Percentage must be a positive number",
        reqTaxName: "Tax Name is required",
        reqEffectiveDate: "Effective Date is required",
        EditTaxMaster: "Edit Tax Master",
        MenuMaster: "Menu Master",
        ParentName: "Parent Name",
        MenuName: "Menu Name",
        PageURL: "Page URL",
        Icon: "Icon",
        CreateMenuMaster: "Create Menu Master",
        EnterMenuName: "Enter Menu Name",
        EnterPageURL: "Enter Page URL ",
        EnterIcon: "Enter Icon ",
        selectParentMenuName: "Select Parent Menu Name ",
        reqMenuName: "Menu Name is required",
        EditMenuMaster: "Edit Menu Master",
        RoleMaster: "Role Master",
        RoleName: "Role Name",
        UserPermissionMaster: "User Permission Master",
        UserName: "User Name",
        CountryMaster: "Country Master",
        CountryName: "Country Name",
        CountryCode: "Country Code",
        Nationality: "Nationality",
        CreateCountryName: "Create Country Name",
        EnterCountryName: "Enter Country Name",
        EnterCountryCode: "Enter Country Code",
        EnterNationality: "Enter Nationality",
        EditCountryMaster: "Edit Country Master",
        StateMaster: "State Master",
        StateName: "State Name",
        StateCode: "State Code",
        CreateStateMaster: "Create State Master",
        EnterStateName: "Enter State Name",
        EnterStateCode: "Enter State Code",
        SelectCountryName: "Select Country Name",
        EditStateMaster: "Edit State Master",
        DistrictMaster: "District Master",
        DistrictName: "District Name",
        DistrictCode: "District Code",
        CreateDistrictMaster: "Create District Master",
        EnterDistrictName: "Enter District Name",
        EnterDistrictCode: "Enter District Code",
        SelectDistrictName: "Select District Name",
        EditDistrictMaster: "Edit District Master",
        GenderMaster: "Gender Master",
        GenderName: "Gender Name",
        GenderCode: "Gender Code",
        CreateGenderMaster: "Create Gender Master",
        reqGenderName: "Gender Name  is required",
        EnterGenderName: "Enter Gender Name",
        EnterGenderCode: "Enter Gender Code",
        SelectGenderName: "Select Gender Name",
        EditGenderMaster: "Edit Gender Master",

        UserManegment: "User Management",
        FirstName: "First Name",
        LoginName: "Login Name",
        MobileNo: "Mobile No",
        Email: "Email",
        DateOfBirth: "Date Of Birth",
        Role: "Role",
        SelectGender: "Select Gender",
        SelectRole: "Select Role",
        SelectUserType: "Select UserType",
        CreateUserManegment: "Create User Management",
        reqFirstName: "First Name Required",
        reqMiddleName: "Middle Name Required",
        reqLastName: "Last Name Required",
        reqloginID: "login ID Required",
        reqPassword: "Password Required",
        reqMobileNumber: "Mobile Number Required",
        reqEmailID: "Email ID Required",
        reqDateofBirth: "Date of Birth Required",
        reqGender: "Gender Required",
        reqUserType: "User Type Required",
        reqRole: "Role Required",
        EnterFirstName: "Enter First Name",
        EnterMiddleName: "Enter Middle Name",
        EnterLastName: "Enter Last Name",
        EnterLoginName: "Enter Login Name",
        EnterPassword: "Enter Password",
        EnterUserCode: "Enter User Code",
        EnterMobileNo: "Enter Mobile No",
        EnterEmailId: "Enter Email-Id",
        EnterDateOfBirth: "Enter Date Of Birth",
        EditUserManegment: "Edit User Management",
        UserTypeMaster: "User Type Master",
        EnterUserType: "Enter User Type",
        UserType: "User Type",
        InvalidUserType: "Invalid User Type",
        enterRoleName: "Enter Role Name",
        reqRoleName: "Role Name Required",
        reqcountryName: "Select Country Name Required",
        reqstateName: "State Name Required",
        reqdistrictName: "District Name Required",
        SelectStateName: "Select State Name",
        SelectWard: "Select Ward",
        reqAreaName: "Advertise Area is required",
        reqNoOfSites: "No Of Sites is  required",
        reqImg: "Advertise image is required",
        reqAdvertisementTypeID: "Select Advertisement Type Required",
        reqMaxLength: "Length is  Required",
        reqMaxWidth: "Width  is Required",
        reqMaxHeight: "Height is  Required",
        reqRatePerSqMtr: "Rate Square Meter is  Required",
        reqPremium: "Premium Amount is  Required",
        RegisterAgency: "Register Agency / Vendor",
        RenewRegisterAgency: "Renew Register Agency / Vendor",
        ApplyDate: "Apply Date",
        NameOfAgency: "Agency Name",
        ContactNo: "Contact No",
        Address: "Address",
        PANNo: "PAN No",
        AadhaarNo: "Aadhaar No",
        GSTNo: "GST No",
        ApplicationFee: "Application Fee",
        SelectCompanyCategory: "Select Company Category",
        reqAadharNumber: "Aadhar Number Required",
        reqBalanceSheet: "Balance Sheet Required",
        reqAddress: "Address Required",
        reqState: "State Required",
        reqEmail: "Email Required",
        reqDistrict: "District Required",
        reqCompanyCategory: "Company Category Required",
        reqPaymentMode: "Payment Mode Required",
        reqTransactionNumber: "Transaction Number Required",
        DateOfApply: "Date Of Apply",
        EnterRegistrationNo: "Enter Registration No",
        EnterName: "Enter Name",
        EnterContactNo: "Enter Contact No",
        EnterEmailID: "Enter Email ID",
        EnterPANNo: "Enter PAN No",
        EnterGSTNo: "Enter GST No",
        EnterAadharNo: "Enter Aadhar No",
        EnterAddress: "Enter Address",
        EnterApplicationFees: "Enter Application Fees",
        EnterRegistrationFees: "Enter Registration Fees",
        reqEnterRegistrationFees: "Registration Fees Required",
        EnterAgencyName: "Enter Agency name",
        EnterDINNumber: "Enter D.I.N. Number",
        DINNumber: "D. I. N. Number",
        EmailID: "Email ID",

        Yes: "Yes",
        No: "No",

        Preview: "Preview",
        Attach: "Attach",

        Back: "Back",
        Submit: "Submit",
        Next: "Next",
        BasicDetails: "Basic Details",
        AgencyDetails: "Agency Details",
        TermsAndConditions: "Terms and Conditions",
        DocUpload: "Document Upload",
        reqApproval: "Approval Required",
        ApprovalRegistration: "Approval for Vendor/Agency Registration",
        AlertBeforeApproval:
          "Are you sure? Has all documents been verified before approval",
        EditAgency: "EDIT AGENCY / VENDOR",
        DefaultFinancialYear: "Default Financial Year",
        IsRateFixed: "Is Rate Fixed",
        EnterRateType: "Enter Rate Type",
        RateType: "Rate Type",
        rate: "Rate",
        SelectRateType: "Select Rate Type",
        YouCannotChangeData: "You can not change this data",
        NoDataAvailable: "No data available",
        PaymentDetails: "Payment Details",

        reqName: "Name Required",
        reqAadhaar: "Aadhaar number is required",
        reqAadhaarexactly: "Aadhaar number must be exactly 12 digits",
        reqMobile: "Mobile Number Required",
        reqRegistrationPayment: "Registration Payment Mode Required",
        reqPanNumber: "Pan Number is required",
        reqGSTINnumber: "GSTIN Number is required",
        reqApplyDate: "Apply Date is required",
        reqAlert:
          "Please fill all required fields (Name of Agency, DIN Number, Email ID, and Mobile Number) before adding to the table.",
        validMobile: "is-valid-mobile",
        InvalidMobile: "Invalid mobile number format",
        validEmail: "is-valid-email",
        InvalidEmail: "Invalid email format",
        EnterApplicationTransaction: "Enter Application Transaction Nos.",
        EnterChequeNo: "Enter Application Cheque Nos.",
        EnterCashReceipt: "Enter Application Receipt Nos.",
        EnterNEFT: "Enter Application NEFT Nos.",
        EnterRTGS: "Enter Application RTGS Nos.",
        SelectRegisPaymentMode: "--Select--",
        EnterRegTransaction: "Enter Registration Transaction Nos.",
        EnterRegChequeNo: "Enter Registration Cheque Nos.",
        EnterRegCashReceipt: "Enter Registration Receipt Nos.",
        EnterRegNEFT: "Enter Registration NEFT Nos.",
        EnterRegRTGS: "Enter Registration RTGS Nos.",
        ApplicationFees: "Application Fees",
        SelectRegistrationPaymentMode: "Select Reg. Payment Mode",
        EnterRegistrationTransactionNumber:
          "Enter Registration Transaction Number",
        RegistrationFees: "Reg. Fees",
        Name: "Name",
        reqFirst: "First Name Required",
        reqLast: "Last Name Required",
        reqLogin: "login ID Required",
        reqDate: "Date of Birth Required",
        reqUser: "User Type Required",
        HearingInformation: "Hearing Information",
        action: "action",
        settled: "settled",
        nextHear: "nextHearing",
        repBy: "reported by",
        remDate: "Remainder Date",
        decision: "decision",
        remark: "remark",
        case_status: "case_status",
        fill_date: "fill_date",
        update_status_date: "update_status_date",
        reqCaseNo: "Case No is required",
        reqAction: "Action is required",
        reqNextHear: "Next Hearing  is required",
        reqRepBy: "reported by is required",
        reqRemDate: "Reminder Date is required",
        reqDecision: "Decision is required",
        reqRemark: "Remark is required",
        reqCaseStatus: "Case status is required",
        reqFillDate: "Fill date is required",
        reqUpdateStatusDate: "Update status date is required",
        caseNo: "caseNo",
        CreateHearingInformation: " Create HearingInformation",
        EnterCaseNo: "Enter Case Number",
        EnterAction: "Enter Action",
        EnterRepBy: "Enter Report By",
        EnterDecision: "Enter Decision",
        EnterRemark: "Enter Remark",
        EnterCaseStatus: "Enter case status",
        EnterFillDate: "Enter Fill Date",
        EnterUpdateDate: "Enter Update Date",
        EnterRemDate: "Enter Reminder Date",
        EnterNextHear: "Enter Next Hearing",
        EditHearingInformation: "Edit  Case Hearing Information",
        DefaultYear: "Default Year",
        CaseStageMaster: "Case Stage Master",
        EnterCaseStage: "Enter Case Stage",
        CaseStage: "Case Stage",
        CaseTypeMaster: "Case Type Master",
        EnterCaseType: "Enter Case Type",
        CaseType: "Case Type",
        CaseCategoryMaster: "Case Category Master",
        EnterCaseCategory: "Enter Case Category ",
        CaseCategory: "Case Category ",
        courtTypeMaster: "Court Type Master",
        EnterCourtType: "Enter Court Type",
        CourtType: "Court Type",
        CourtNameMaster: "Court Name Master",
        EnterCourtName: "Enter Court Name",
        CourtName: "Court Name",
        CrimeNatureMaster: "Crime Nature Master",
        EnterCrimeNature: "Enter Crime Nature",
        CrimeNature: "Crime Nature",
        PetitionerPersonalInformation: "Petitioner Personal Information",
        WritNo: " Writ No",
        Casecategory: "Case Category ",
        CounselForPetitioner: "Counsel for Petitioner",
        OICEmail: "officer Incharge Email",
        OICMobile: "officer Incharge Mobile",
        PetitionerName: "Petitioner name",
        CaseDate: "Case Date",
        MobileNumber: "Mobile Number",
        CaseStatus: "Case Status",
        reqCourtType: "Court Type Required",
        reqCaseCategory: "Case Category Required",
        reqCaseType: "Case Type Required",
        reqCourtName: "Court Name Required",
        reqCrimeNature: "Crime Nature Required",
        reqCaseStage: "Case Stage Required",
        SelectCaseType: "Select Case Type",
        SelectCaseCategory: "Select Case Category",
        createPetitioner: " Create Petitioner Personal Information",
        EnterWritNo: "Enter Writ no",
        EnterCounselForPetitioner: "Enter Counsel for Petitioner",
        EnterEmail: "Enter Email",

        deptMaster: "Department Master",
        deptName: "Dept. Name",
        deptCode: "Dept. Code",
        createdeptmaster: " Create Department Master",
        editdeptmaster: "Edit Department Master",
        enterdeptName: "Enter Department Name",
        enterdeptCode: "Enter Department Code",
        reqdept_name: "Department Name Required",
        desName: "Designation Master",
        createddesigMAster: "Create Designation Master",
        reqdesignname: "Designation Name Required,",
        enterDesName: "Enter Designation Name",
        entershortCode: " Enter Designation Code",
        selectDet: "Select Department",
        reqdept_id: "Select Department Required",
        editdesMaster: "Edit Designation Master",
        AttachImg: "Attach Transaction Receipt",
        SelectDepartment: "Select Department",
        SelectDesignation: "Select Designation",
        PrintPreview: "Print Preview",

        FileClass: "File Class",
        classDescription: "Class Description",
        shortName: "Short Name",
        weedingOutAuthority: "Weeding Out Authority",
        CreateclassDescription: "Create Class Description",
        EnterShortName: "Enter Short Name",
        EnterClassDescription: "Enter Class Description",
        EnterWeedingOutAuthority: "Enter Weeding Authority ",
        CreateFileClass: "Create File Class",
        EditFileClass: "Edit File Class",
        FileGroupName: "File Group Name",
        EnterFileGroupName: "Enter File Group Name",
        FileGroup: "File Group",
        FileSubject: "File Subject",
        EnterFileSubjectName: " Enter File Subject Name",
        FileSubjectName: "File Subject Name",
        ShortName: "Short Name",
        FileType: "File Type",
        EnterFileTypeName: "Enter File Type Name",
        FileTypeName: "File Type Name ",
        SelectFileGroup: "Select File Group",
        SelectFileCategory: "Select File Category",
        SelectFileType: "Select File Type",
        SelectFileNo: "Select File Number",
        SelectFileClass: " Select File Class",
        SelectFileSubject: "Select File Subject",
        ReceiptStatus: "Receipt Status",
        RecName: "Receipt Name",
        EnterRecName: "Enter Receipt Name",
        ReceiptType: "Receipt Type",
        ReceiptName: "Receipt Name",
        EnterReceiptName: "Enter Receipt Name",
        RecStatus: "Receipt Status",
        EnterRecStatus: "Enter Receipt Status",
        reqRecStatus: "Require Receipt Status ",
        Location: "Location",
        LocationName: "Location Name",
        EnterLocationName: "Enter Location Name",
        LocationShortName: " Location Short Name",
        EnterLocationShortName: "Enter Location Short Name",
        senderID: "Sender ID",
        receiverID: " Recever ID",
        currentLocation: " Current Location",
        EnterSignatureUpload: "Attach Signature",
        EnterLocationObject: "Enter Location Object",
        EnterAbbreviation: "Enter Abbreviation",
        Abbreviation: "Abbreviation",
        LocationObject: "Location Object",
        reqLocationObject: "Require Location Object ",
        reqFileGroupName: "Require File Group Name",
        reqFileSubjectName: "Require File Subject Name",
        reqFileTypeName: "Require File Type Name",
        reqReceiptName: "Require Receipt Name",
        EnterDocUpload: "Attach Document",
        EnterDocSubType: "Document Subject Type",
        EnterSubDocAbbreviation: "Document Subject Abbreviation",
        SelectDoctype: "Select Document Type",
        SelectFileName: "Select file Name",
        SelectSubject: "Select Subject",
        EnterSubFtype: "subject file type",
        SelectDivision: "Select Division",
        EnterCountryShortName: " Enter Country Short Name",
        EnterStateShortName: "Enter State Short Name",
        EnterdisplayNo: "Enter Display Number",
        SelectDocType: "Select Document Type",
        enterDesCode: "Enter Designation Code",
        DesignationName: "Designation Name",
        DesignationCode: "Designation Code",
        DocType: "Document Type",
        DocSubType: "Document Sub Type",
        CreateDocType: "Create Document Type",
        EditDocType: "Edit Document Type",
        EnterDocType: "Enter Document Type",
        EntryDate: "Entry Date",
        EnterDocName: "Enter Document Name",
        DocSubject: "Document Subject",
        Subject: "Subject",
        DocSubSubject: "Document Sub Subject",
        SubSubject: "Sub Subject",
        FileNo: "File Number",
        Synopsis: "Synopsis",
        FileDef: "File Definition",
        DocumentEntry: "Document Entry",
        DocumentEntryAdd: "Add Document Entry ",
        reqFileNo: "File No Is Require",
        EnterFileNo: "Enter File Number",
        EnterSynopsis: "Enter Synopsis",
        EnterPartNo: "Enter Part Number",
        EnterPeriodFileUpto: "Enter Period File Upto",
        EnterSubject: "Enter Subject",
        EnterFileDef: "Enter File Definition",
        EnterComplete: "Enter Complete",
        EnterAuthenticatePerson: "Enter Authenticated Person",
        EnterFileDate: "Enter File Date",
        SelectFile: "Select File",
        SelectSubject: "Select Subject",
        SelectDivision: "Select Division",
        EnterPeriodDate: "Enter Period Date",
        AttachedFile: "Attached File",
        EnterFileName: "Enter File Name",
        PeriodDate: "Period Date",
        Keywords: "Keywords",
        FileName: "File Name",
        PdfFile: "PDF File",
        DocumentEntryEdit: "Edit Document Entry ",
        EnterKeyword: "Enter Keyword",
        PdfName: "PDF Name",
        DocFiles: "Document Files",
        SelectDoc: "Select Document",
        SelectLocation: "Select Location",
        reqPdfName: "PDF Name Is Require",
        CreateDocFiles: "Create Document Files",
        EditDocFiles: "Edit Document Files",
        EnterPdfName: "Enter PDF Name",
        EnterKeywords: "Enter Keywords",
        EnterSubFtype: "Enter Sub File Type",
        EnterPdfDate: "Enter PDF Date",
        DocPages: "Document Pages",
        Comments: "Comments",
        PhysicalSerialNo: "Physical Serial Number",
        PhysicalIndex: "Physical Index",
        CreateDocPages: "Create Document Pages",
        EditDocPages: "Edit Document Pages",
        PageNoFrom: "Page Number From",
        PageNoUpto: "Page Number Upto",
        EnterComments: "Enter Comments",
        EnterPhysicalSerialNo: "Enter Physical Serial Number",
        EnterPhysicalIndex: "Enter Physical Index",
        SelectField: "Select Field",
        DocViewer: "Document Viewer",
        SubFileType: "Sub File Type",
        ViewPdf: "View PDF",
        View: "VIEW",
        NoRecordAvailable: "No Record Available",
        NoPdfAvailable: "No PDF Available",
        AddComment: "Add Comment",
        PageNoFrom: "Page Number From",
        PageNoTo: "Page Number To",
        RelatedOficer: "Related Oficer",
        AddRow: "Add Row",
        Index: "Index!",
        SelectDevision: "Select Devision",
        SelectFileStatus: "Select File Status",
        DocumentIndexing: "Document Indexing",
        Filter: "Filter",
        Print: "Print",
        PeriodFrom: "Period From",
        PeriodTo: "Period To",
        Search: "Search",
        Clear: "Clear",
        ViewIndexPdf: "View Index PDF",
        ViewFullPdf: "View Full PDF",
        FileDefinition: "File Definition",
        SearchKeywords: "Search Keywords",
        DateFrom: "Date From",
        DateTo: "Date To",
        Complete: "Complete",
        SplitPdfToJump: "Split PDF To Jump",
        SplitPage: "Split Page",
        PdfFileName: "PDF File Name",
        PageFrom: "Page From",
        PageTo: "Page To",
        ViewFile: "View File",
        AddPdf: "Add PDF",
        DocUpload: "Document Upload",
        EnterRemark: "Enter Remark",
        EnterValue: "Enter Value",
        FileSaved: "File Saved",
        EnterMainPdf: "Enter Main PDF",
        EnterPdf: "Enter PDF",
        PdfMearge: "PDF Mearge",
        SplitMainFile: "Split Main File",
        ForRename: "For Rename",
        ForShiftCategory: "For Shift Category",
        UpdatePdf: "Update PDF",
        PdfCounter: "PDF Counter",
        EnterFolderPath: "Enter Folder Path",
        Count: "Count",
        EmployeeEntry: "Employee Entry",
        EmployeeName: "Employee Name",
        Login: "Login",
        Password: "Password",
        Edit: "Edit",
        delete: "Delete",
        Export: "Export",
        Release: "Release",
        Post: "Post",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        EmployeeMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        SelectState: "Select State",
        SelectCountry: "Select Country",
        SelectDistrict: "Select District",
        reqEmpName: "Employee name Is Require",
        reqEmpCode: "Employee Code is Require",
        reqFatherName: "Father Name Is Require",
        reqMobNo: "Mobile Number Is Require",
        reqPanNo: "Pan Number Is Require",
        reqJoiningDate: "Joining Date Is Require",
        reqDesignation: "Designation Is Require",
        reqDepartment: "Department Is Require",
        reqPerAddress: "Permanent Address Is Require",
        reqPinCode: "Pin Code Is Require",
        reqAdharNo: "Aadhar Number Is Require",
        reqEmail: "Email Is Require",
        reqEmpdob: "Employee DOB Is Required",
        CreateEmployeeReg: "Create Employee Registration",
        EditEmployeeReg: "Edit Employee Registration",
        EnterEmpName: "Enter Employee Name",
        EnterEmpCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterSpauseName: "Enter Spause Name",
        EnterMotherName: "Enter Mother Name",
        EnterMobileNumber: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan Number",
        EnterAdharNo: "Enter Aadhar Number",
        EnterDOB: "Enter Date Of Birth",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        EnterLocalAddress: "Enter Local Address",
        EnterPerAddress: "Enter Permanent Address",
        EnterPinCode: "Enter Pin Code",
        AttachedImage: "Attached Image",
        DocManagerReport: "Document Manager Report",
        SelectSubSubject: " Select Sub Subject",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Remark: "Remark",
        SessionYear: "Session Year",
        InActive: "InActive",
        Active: "Active",
        TotalDoc: "Total Document",
        TotalType: "Total Type",
        TotalIndexFile: "Total Index File",
        TotalSplitFile: "Total Split File",
        Zone: "Zone",
        LineChart: "Line Chart",
        Department: "Department",
        AcademicDepartment: "Academic Department",
        DocumentManagementSystem: "Digital Document Management System Software",
        DocMng: "Document Manager",
        PartNo: "Part Number",
        PeriodFileNo: "Period File Number",
        AuthonticatedPerson: "Authonticated Person",
        FileDate: "File Date",
        SubjectId: "Subject ID",
        ToDate: "To Date",
        MergeToIndexFile: "Merge To Index File",
        MergeToOriginalFile: "Merge To Original File",
        DOB: "Date Of Birth",
        Comment: "Comment",
        HelpDesk: "Help Desk",
        HelpCreation: "Help Creation",
        AddNewRole: "Add New Role",
        AssignPermissions: "Assign Permissions ",
        EditRole: "Edit Role",
        AddUserPermissions: "Add User Permissions",
        EditUserPermissions: "Edit User Permissions",
        cancel: "Cancel",
        Searching: "Searching",
        PdfPreview: "Pdf Preview ",
        PageCount: "Page Count",
        Results: "Results",
        FilePath: "File Path",
        SelectedFilePath: "Selected File Path",
        NoFileSelected: "No File Selected",
        CountPages: "Count Pages",
        Counting: "Counting",
        selectTypeToViewDocs: "Select Type To View Docs",
        TextSearch: "Text Search",
        PeriodUpto: "Period Upto",
        Details: "Details",
        NoDataFound: "No Data Found",
        AddEditCommentsFor: "Add Edit Comments For ",
        SaveComments: "Save Comments",
        SrNO: "Sr No",
        PageTitle: "Page Title",
        FilterOptions: "Filter Options",
        SelectOrEnterFileNo: "Select or Enter File No",
        LoadingData: "Loading Data...",
        FiltersCleared: "Filters Cleared",
        DownloadPDF: "Download PDF",
        SelectFileType: "Select File Type",
        EnterPeriodFileFrom: "Enter Period File From",
        reqsubsubjId: "Subject is required",
        reqdivisionid: "Department is required",
        SelectPdf: "Select PDF",
        SplitFileView: "Split File View",
        NoPDFPreviewAvailable: "No PDF Preview Available",
        LoadingPDF: "Loading PDF",
        reqfileTypeID: "File Type is required",
        reqFileStatus: "File Status is required",
        reqFileName: "File Name is required",
        PageName: "Page Name",
        FilePathRequired: "File Path is required",
        Attachments: "Attachments",
        SelectedFileName: "Selected File Name",

        NoReportsFound: "No Reports Found",
        Date: "Date",
        Process: "Process",
        Pending: "Pending",
        Complete: "Complete",
        DocManagerReport: "Document Manager Report",
        Filter: "Filter",
        Print: "Print",
        Search: "Search",
        Searching: "Searching",
        Clear: "Clear",
        NoDataFound: "No data found",
        ErrorFetchingData: "Error fetching data",
        NetworkError: "Network error occurred",
        ErrorFetchingFilters: "Error fetching filter options",
        FiltersCleared: "Filters cleared",
        FilterOptions: "Filter Options",
        SelectDivision: "Select Division",
        SelectSubSubject: "Select Sub Subject",
        SelectFileType: "Select File Type",
        SelectOrEnterFileNo: "Select or Enter File No",
        SelectStatus: "Select Status",
        FromDate: "From Date",
        ToDate: "To Date",
        SrNo: "Sr. No",
        FileName: "File Name",
        Subject: "Subject",
        FileNo: "File No",
        FileType: "File Type",
        SubSubjectName: "Sub Subject Name",
        DivisionName: "Division Name",
        Date: "Date",
        LoadingData: "Loading data",
        NoReportsFound: "No reports found",
        NoMatchingResults: "No matching results found",
        Details: "Details",
        DocumentManager: "Document Manager",
        requestInProgress: "Request already in progress",
        tooManyRequests: "Too many requests. Please wait a moment",
        somethingWentWrong: "Something went wrong. Please try again",
        submitting: "Submitting...",
        save: "Save",
        reset: "Reset",
        CreateCountryName: "Create Country",
        EnterCountryName: "Enter Country Name",
        EnterCountryShortName: "Enter Country Short Name",
        countryNameMaxLength: "Country name cannot exceed 20 characters",
        countryShortNameMaxLength:
          "Country short name cannot exceed 10 characters",
        RoleAddedSuccess: "Role added successfully",
        RoleUpdatedSuccess: "Role updated successfully",
        ConfirmDeleteRecord: "Are you sure you want to delete this record?",
        DeleteConfirmation: "Delete Confirmation",
        DeleteOperationCancelled: "Delete Operation Cancelled",
        ApiCalledFailed: "API Called Failed",
        RoleDeletedSuccess: "Role deleted successfully",
        ErrorDeletingRole: "Error deleting role",
        ConfirmDeleteUserPermissions:
          "Are you sure you want to delete these user permissions?",
        invalidCountryName:
          "Country name can only contain letters, spaces, and hyphens",
        invalidCountryShortName:
          "Country short name can only contain letters and hyphens",
        noSpecialCharsStartEnd:
          "Country name cannot start or end with special characters",
        noSpecialCharsStartEndShort:
          "Short name cannot start or end with special characters",
        noMultipleSpecialChars:
          "Country name cannot have multiple consecutive special characters",
        passwordValidation:
          "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., !@#$%^&*)",
        subDeptMaster: "Sub Department Master",
        subDeptName: "Sub Department Name",
        CreateSubDeptMaster: "Create Sub Department",
        EditSubDeptMaster: "Edit Sub Department",
        EnterSubDeptName: "Enter Sub Department Name",
        SelectDepartment: "Select Department",
        reqDeptName: "Department name is required",
        reqSubDeptName: "Sub department name is required",
        invalidDepartmentSelection: "Please select a valid department",
        invalidSubDeptName:
          "Sub department name can only contain letters, numbers, spaces, hyphens, &, ., ,, (, )",
        subDeptNameMaxLength: "Sub department name cannot exceed 50 characters",
        noSpecialCharsStartEnd: "Cannot start or end with special characters",
        noMultipleSpecialChars:
          "Cannot have multiple consecutive special characters",
        failedToLoadDepartments: "Failed to load departments",
        badRequest: "Invalid request data",
        selectOption: "Select an option",
        submitting: "Submitting...",
        save: "Save",
        update: "Update",
        reset: "Reset",
        requestInProgress: "Request in progress, please wait...",
        tooManyRequests: "Too many requests, please try again later",
        somethingWentWrong: "Something went wrong, please try again",
        SelectSubDept: "Select Sub Department",
        newNodeMaster: "New Node Master",
        addNewNode: "Add New Node",
        editNode: "Edit Node",
        nodeID: "Node ID",
        nodeName: "Node Name",
        enterNodeName: "Enter node name",
        save: "Save",
        update: "Update",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        nodeIDRequired: "Node ID is required",
        nodeIDMinValue: "Node ID must be 0 or greater",
        nodeNameRequired: "Node name is required",
        nodeNameMaxLength: "Node name cannot exceed 100 characters",
        invalidNodeName:
          "Invalid node name. Only letters, numbers, spaces, hyphens, &, ., ,, and () are allowed",
        noSpecialCharsStartEnd:
          "Node name cannot start or end with special characters",
        nodeAddedSuccessfully: "Node added successfully",
        nodeUpdatedSuccessfully: "Node updated successfully",
        nodeDeletedSuccessfully: "Node deleted successfully",
        deleteConfirmation: "Delete Confirmation",
        deleteConfirmationMessage: "Are you sure you want to delete this node?",
        deleteCancelled: "Delete cancelled",
        operationFailed: "Operation failed",
        deleteFailed: "Failed to delete node",
        nodeNotFound: "Node not found",
        badRequest: "Bad request",
        somethingWentWrong: "Something went wrong. Please try again.",
        failedToLoadNodes: "Failed to load nodes",
        requestInProgress: "Request in progress",
        tooManyRequests: "Too many requests. Please try again later.",
        Action: "Action",
        SrNo: "Sr. No",
      },

      content: {},
    },
  },
  hi: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        zoneMaster: "ज़ोन मास्टर",
        add: "जोड़ें",
        print: "प्रिंट",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        Action: "क्रिया",
        SrNo: "क्रम संख्या",
        zoneName: "जोन का नाम",
        zoneCode: "ज़ोन कोड",
        Status: "स्थिति",
        search: "खोजें",
        save: "सहेजें",
        reset: "रीसेट करें",
        createZoneMaster: "ज़ोन मास्टर बनाएं",
        editZoneMaster: "ज़ोन मास्टर संपादित करें",
        enterZoneName: "ज़ोन का नाम ",
        enterZoneCode: "ज़ोन का कोड ",
        req: "ज़ोन का नाम आवश्यक है",
        update: "अपडेट",
        wardMaster: "वार्ड मास्टर",
        wardName: "वार्ड का नाम",
        wardCode: "वार्ड कोड",
        createWardMaster: "वार्ड मास्टर बनाएं",
        editWardMaster: "वार्ड मास्टर संपादित करें",
        enterWardName: "वार्ड का नाम ",
        enterWardCode: "वार्ड का कोड ",
        req1: "वार्ड का नाम आवश्यक है",
        SelectZoneName: "जोन का नाम चुनें",
        reqSelectZoneName: "आवश्यक जोन नाम का चयन करें",
        CategoryMaster: "श्रेणी मास्टर",
        CategoryName: "श्रेणी नाम",
        EnterCategoryName: "श्रेणी का नाम दर्ज करें",
        CreateCategoryMaster: "श्रेणी मास्टर बनाएं",
        reqCategory: "आवश्यक श्रेणी नाम दर्ज करें",
        EditCategoryMaster: "श्रेणी मास्टर संपादित करें",
        SubCategoryMaster: "उप श्रेणी मास्टर",
        SubCategoryName: "उप श्रेणी का नाम",
        RemarkName: "टिप्पणी",
        CreateSubCategoryMaster: "उपश्रेणी मास्टर बनाएँ",
        EnterSubCategoryName: "उप श्रेणी का नाम दर्ज करें",
        EnterCategoryRemark: "श्रेणी टिप्पणी दर्ज करें",
        reqSelectCategory: "*कृपया श्रेणी चुनें",
        reqEnterSubCategory: "उप श्रेणी नाम दर्ज करना आवश्यक होना चाहिए",
        SelectCategory: "श्रेणी चुनना",
        EditSubCategoryMaster: "उपश्रेणी मास्टर संपादित करें",

        FromDate: "तारीख से",
        Todate: "तारीख तक",

        Description: "विवरण",
        MaxLength: "लंबाई",
        MaxWidth: "चौड़ाई",
        MaxHeight: "ऊँचाई",
        AreaSquareMeter: "क्षेत्रफल वर्ग मीटर",
        ratePerSqMtr: "दर प्रति वर्गमीटर",
        Amount: "मात्रा",
        Premium: "अधिमूल्य",

        MenuMaster: " मेनू मास्टर",
        ParentName: "अभिभावक का नाम",
        MenuName: "मेनू नाम",
        PageURL: "पेज यूआरएल",
        Icon: "आइकन",
        CreateMenuMaster: "मेनू मास्टर बनाएं",
        EnterMenuName: "मेनू नाम दर्ज करें",
        EnterPageURL: "पेज यूआरएल दर्ज करें",
        EnterIcon: "चिह्न दर्ज करें",
        selectParentMenuName: "पेरेंट मेनू नाम चुनें",
        reqMenuName: "मेनू नाम आवश्यक है",
        EditMenuMaster: "मेनू मास्टर संपादित करें",
        RoleMaster: " रोल मास्टर",
        RoleName: "भूमिका का नाम",
        UserPermissionMaster: "उपयोगकर्ता अनुमति मास्टर",
        UserName: "उपयोगकर्ता नाम",
        CountryMaster: "देश मास्टर",
        CountryName: "देश  का नाम",
        CountryCode: "देश कोड",
        Nationality: "राष्ट्रीयता",
        CreateCountryName: "देश का नाम बनाएं",
        EnterCountryName: "देश का नाम दर्ज करें",
        EnterCountryCode: "देश कोड दर्ज करें",
        EnterNationality: "राष्ट्रीयता दर्ज करें",
        EditCountryMaster: "देश मास्टर संपादित करें",
        StateMaster: "राज्य मास्टर",
        StateName: "राज्य का नाम",
        StateCode: "राज्य कोड",
        CreateStateMaster: "राज्य मास्टर बनाएं",
        EnterStateName: "राज्य का नाम दर्ज करें",
        EnterStateCode: "राज्य कोड दर्ज करें",
        SelectCountryName: "देश का नाम चुनें",
        EditStateMaster: "राज्य मास्टर संपादित करें",
        DistrictMaster: "ज़िला मास्टर",
        DistrictName: "ज़िला का नाम",
        DistrictCode: "ज़िला कोड",
        CreateDistrictMaster: "ज़िला का नाम दर्ज करें",
        EnterDistrictName: "ज़िला का नाम दर्ज करें",
        EnterDistrictCode: "ज़िला कोड दर्ज करें",
        SelectStateName: "राज्य  का नाम चुनें",
        EditDistrictMaster: "ज़िला  मास्टर संपादित करें",
        GenderMaster: "लिंग मास्टर",
        GenderName: "लिंग का नाम",
        GenderCode: "लिंग कोड",
        CreateGenderMaster: "लिंग का नाम दर्ज करें",
        reqGenderName: "लिंग नाम आवश्यक है",
        EnterGenderName: "लिंग का नाम दर्ज करें",
        EnterGenderCode: "लिंग कोड दर्ज करें",
        SelectGenderName: "लिंग का नाम चुनें",
        EditGenderMaster: "लिंग  मास्टर संपादित करें",

        Total: "कुल",
        RegNo: " संख्या",
        NameOfPlace: "उप विज्ञापन के प्रकार का नाम",
        Size: "आकार",
        Sqmtr: "वर्ग मीटर",
        Rate: "दर",
        NetAmount: "शुद्ध राशि",
        PaymentMode: "भुगतान का प्रकार",
        Deposit: "जमा",
        Remaining: "शेष",

        Date: "तारीख",

        CreateDirectApplyforAdvertisement: "विज्ञापन के लिए सीधा आवेदन बनाएं",

        UserManegment: "प्रयोक्ता प्रबंधन",
        FirstName: "पहला नाम",
        LoginName: "लॉगिन नाम",
        MobileNo: "मोबाइल नंबर",
        Email: "ईमेल",
        DateOfBirth: "जन्म की तारीख",
        Role: "भूमिका",
        SelectGender: "लिंग चुनें",
        SelectRole: "भूमिका चुनें",
        SelectUserType: "उपयोगकर्ता प्रकार चुनें",
        CreateUserManegment: "उपयोगकर्ता प्रबंधन बनाएं",
        reqFirstName: "पहला नाम आवश्यक है",
        reqMiddleName: "मध्य नाम आवश्यक है",
        reqLastName: "अंतिम नाम आवश्यक है",
        reqloginID: "लॉगिन नाम आवश्यक है",
        reqPassword: "पासवर्ड की आवश्यकता है",
        reqMobileNumber: "मोबाइल नंबर आवश्यक है",
        reqEmailID: "ईमेल आईडी आवश्यक है",
        reqDateofBirth: "जन्म तिथि आवश्यक है",
        reqGender: "लिंग आवश्यक है",
        reqUserType: "उपयोगकर्ता प्रकार आवश्यक है",
        reqRole: "भूमिका आवश्यक है",
        EnterFirstName: "प्रथम नाम दर्ज करें",
        EnterMiddleName: "मध्य नाम दर्ज करें",
        EnterLastName: "अंतिम नाम दर्ज करो",
        EnterLoginName: "लॉगिन नाम दर्ज करें",
        EnterPassword: "पास वर्ड दर्ज करें",
        EnterUserCode: "उपयोगकर्ता कोड दर्ज करें",
        EnterMobileNo: "मोबाइल नंबर दर्ज करें",
        EnterEmailId: "ईमेल-आईडी दर्ज करें",
        EnterDateOfBirth: "जन्म तारीख दर्ज करें",
        EditUserManegment: "उपयोगकर्ता प्रबंधन संपादित करें",
        UserTypeMaster: "उपयोगकर्ता प्रकार मास्टर",
        EnterUserType: "उपयोगकर्ता प्रकार दर्ज करें",
        UserType: "उपयोगकर्ता का प्रकार",
        InvalidUserType: "अमान्य उपयोक्ता प्रकार",
        SelectWard: "वार्ड का चयन करें",
        reqAreaName: "विज्ञापन क्षेत्र आवश्यक है",
        reqNoOfSites: "साइटों की संख्या आवश्यक है",
        reqImg: "विज्ञापन छवि आवश्यक है",
        reqAdvertisementTypeID: "आवश्यक विज्ञापन प्रकार का चयन करें",
        reqMaxLength: "अधिकतम लंबाई आवश्यक है",
        reqMaxWidth: "अधिकतम चौड़ाई आवश्यक है",
        reqMaxHeight: "अधिकतम ऊंचाई आवश्यक है",
        reqRatePerSqMtr: "प्रति वर्ग मीटर आवश्यक है",
        reqPremium: "प्रीमियम राशि आवश्यक है",
        enterRoleName: "भूमिका का नाम दर्ज करें",
        reqEnterNotice: "सूचना  दर्ज करना आवश्यक है",
        reqEnterNoticeLink: "सूचना  दर्ज करें लिंक आवश्यक है",
        reqEnterDescription: "विवरण दर्ज करना आवश्यक है",
        rowsperpage: "प्रति पृष्ठ पंक्तियाँ:",
        reqcountryName: "देश का नाम आवश्यक है",
        reqRoleName: "भूमिका का नाम आवश्यक है",
        reqstateName: "राज्य का नाम आवश्यक है",
        reqdistrictName: "ज़िला का नाम आवश्यक है",
        RegisterAgency: "रजिस्टर एजेंसी / विक्रेता",
        RenewRegisterAgency: "नवीनीकरण रजिस्टर एजेंसी/विक्रेता",
        ApplyDate: "आवेदन की तिथि",
        NameOfAgency: "एजेंसी का नाम",
        ContactNo: "संपर्क नंबर",
        Address: "पता",
        PANNo: "पैन नंबर",
        AadhaarNo: "आधार नंबर",
        GSTNo: "जीएसटी नंबर",
        ApplicationFee: "आवेदन शुल्क",
        SelectCompanyCategory: "कंपनी श्रेणी चुनें",
        reqAadharNumber: "आधार नंबर आवश्यक है",
        reqBalanceSheet: "बैलेंस शीट आवश्यक है ",
        reqAddress: "पता आवश्यक है",
        reqState: "राज्य आवश्यक है",
        reqEmail: "ईमेल आवश्यक है",
        reqDistrict: "जिला आवश्यक है",
        reqCompanyCategory: "कंपनी श्रेणी आवश्यक है",
        reqPaymentMode: "भुगतान मोड आवश्यक है",
        reqTransactionNumber: "लेनदेन संख्या आवश्यक है",
        DateOfApply: "आवेदन करने की तिथि",
        EnterRegistrationNo: "पंजीकरण संख्या दर्ज करें",
        EnterName: "नाम दर्ज करें",
        EnterContactNo: "संपर्क नंबर दर्ज करें",
        EnterEmailID: "ईमेल आईडी दर्ज करें",
        EnterPANNo: "पैन नंबर दर्ज करें",

        EnterAadharNo: "आधार नंबर दर्ज करें",
        EnterAddress: "पता दर्ज करें",
        EnterApplicationFees: "आवेदन शुल्क दर्ज करें",
        EnterRegistrationFees: "पंजीकरण शुल्क दर्ज करें",
        reqEnterRegistrationFees: "पंजीकरण शुल्क आवश्यक",
        EnterAgencyName: "एजेंसी का नाम दर्ज करें",
        EnterDINNumber: "डी. आई. एन. संख्या दर्ज करें",
        DINNumber: "डी. आई. एन. नंबर",
        EmailID: "ईमेल आईडी",
        SangamArticle: "कंपनी के समय ज्ञापन तथा संगठन अनुछेद",
        AuthorityExpAdvert:
          "पिछले 3 वर्षों के विज्ञापन व्यवसाय में अभिकरण/फॉर्म का अनुभव",
        Yes: "हाँ",
        No: "नहीं",

        Preview: "पूर्व दर्शन",
        Attach: "संलग्न करना:",

        AttachAadhaarDocument: "आधार दस्तावेज़ संलग्न करें",
        UploadPANDocument: "पैन दस्तावेज़ अपलोड करें",
        OtherDocument: "अन्य दस्तावेज़",
        CreateAgency: "एजेंसी/विक्रेता बनाएं",
        RenewCreateAgency: "नवीनीकरण एजेंसी/विक्रेता",
        EditRenewAgecy: "पंजीकरण एजेंसी/विक्रेता संपादित करें",
        Back: "पीछे",
        Submit: "जमा करना",
        Next: "अगला",
        BasicDetails: "बुनियादी विवरण",
        AgencyDetails: "एजेंसी विवरण",
        TermsAndConditions: "नियम और शर्तें",
        DocUpload: "दस्तावेज़ अपलोड करें",

        EditAgency: "संपादन एजेंसी/विक्रेता",
        DefaultFinancialYear: "डिफ़ॉल्ट वित्तीय वर्ष",
        DayWise: "दिन के अनुसार",
        MonthWise: "माह के अनुसार",
        YearWise: "वर्ष के अनुसार",
        rate: "दर",
        IsRateFixed: "दर तय है",
        EnterRateType: "दर प्रकार दर्ज करें",
        RateType: "दर प्रकार",

        reqName: "नाम आवश्यक है",
        reqAadhaar: "आधार नंबर आवश्यक है",
        reqAadhaarexactly: "आधार नंबर बिल्कुल 12 अंकों का होना चाहिए",
        reqMobile: "मोबाइल नंबर आवश्यक है",
        reqRegistrationPayment: "पंजीकरण भुगतान मोड आवश्यक है",
        reqPanNumber: "पैन नंबर आवश्यक है",
        reqGSTINnumber: "जीएसटीआईएन नंबर आवश्यक है",
        reqApplyDate: "आवेदन तिथि आवश्यक है",
        reqAlert:
          "कृपया तालिका में जोड़ने से पहले सभी आवश्यक फ़ील्ड (एजेंसी का नाम, डीआईएन नंबर, ईमेल आईडी और मोबाइल नंबर) भरें।",
        validMobile: "वैध-मोबाइल है",
        InvalidMobile: "अमान्य मोबाइल नंबर फॉर्मेट है",
        validEmail: "वैध-ईमेल है",
        InvalidEmail: "अमान्य ईमेल प्रारूप है",

        Name: "नाम",
        reqFirst: "पहला नाम आवश्यक है",
        reqLast: "अंतिम नाम आवश्यक है",
        reqLogin: "लॉगिन आईडी आवश्यक है",
        reqDate: "जन्म तिथि आवश्यक है",
        reqUser: "उपयोगकर्ता प्रकार आवश्यक है",

        deptMaster: "विभाग मास्टर",
        deptName: "विभाग का नाम",
        deptCode: "विभाग कोड",
        createdeptmaster: "विभाग मास्टर बनाएँ",
        editdeptmaster: "विभाग मास्टर संपादित करें",
        enterdeptName: "विभाग का नाम दर्ज करें",
        enterdeptCode: "विभाग कोड दर्ज करें",
        reqdept_name: "विभाग का नाम आवश्यक",
        desName: "पदनाम मास्टर",
        createddesigMAster: "पदनाम बनाएं मास्टर",
        reqdesignname: "पदनाम नाम आवश्यक है",
        enterDesName: "पदनाम नाम दर्ज करें",
        entershortCode: "पदनाम कोड दर्ज करें",
        selectDet: "विभाग का चयन करें",
        reqdept_id: "आवश्यक विभाग का चयन करें",
        editdesMaster: "पदनाम संपादित करें मास्टर",
        AttachImg: "लेनदेन रसीद संलग्न करें",
        SelectDepartment: "विभाग का चयन करें",
        SelectDesignation: "पदनाम का चयन करें",
        CreatePetitionerPersonalInformation:
          "याचिकाकर्ता की व्यक्तिगत जानकारी बनाएँ",
        EnterCouncelForRespondent: "प्रतिवादी के लिए परामर्श दर्ज करें",
        EnterRespondentContact: "प्रतिवादी संपर्क दर्ज करें",
        EnterRespondentEmail: "प्रतिवादी ईमेल दर्ज करें",
        SelectCaseNo: "केस नंबर चुनें",
        SelectCourtName: "न्यायालय का नाम चुनें",
        SelectCourtType: "न्यायालय प्रकार का चयन करें",
        EnterRespodingCounselName:
          "प्रत्युत्तर देने वाले वकील का नाम दर्ज करें",
        BaseYear: "आधार वर्ष",
        baseYearName: "आधार वर्ष का नाम",
        DefaultbaseYear: "डिफ़ॉल्ट आधार वर्ष",
        ReqEnterbaseYearName: "आवश्यक आधार वर्ष दर्ज करें",
        CreateBaseYearMaster: "आधार वर्ष मास्टर बनाएं ",
        EditBaseYearMaster: "आधार वर्ष मास्टर संपादित करें",
        SelectBaseYear: "आधार वर्ष चुनें",
        effectiveDate: "प्रभावी तिथि",
        EntryDate: "प्रवेश तिथि",
        SqFt: "वर्ग फुट",
        ReqDate: "दिनांक आवश्यक है",
        ReqFree: "निःशुल्क आवश्यक है",
        ReqRate: "दर आवश्यक है",
        TransactionImage: "रसीद संलग्न करें",
        reqRateType: "दर प्रकार आवश्यक है",
        FileClass: "फ़ाइल वर्ग",
        classDescription: "वर्ग विवरण",
        shortName: "संक्षिप्त नाम",
        weedingOutAuthority: "प्राधिकरण को हटाना",
        CreateclassDescription: "कक्षा विवरण बनाएँ ",
        EnterShortName: "संक्षिप्त नाम दर्ज करें",
        EnterClassDescription: "कक्षा विवरण दर्ज करें",
        EnterWeedingOutAuthority: "प्राधिकरण को बाहर निकालने में प्रवेश करें",
        CreateFileClass: "फ़ाइल वर्ग बनाएँ",
        EditFileClass: "फ़ाइल वर्ग संपादित करें",
        FileGroupName: "फ़ाइल समूह का नाम",
        EnterFileGroupName: "फ़ाइल समूह का नाम दर्ज करें",
        FileGroup: "फ़ाइल समूह",
        FileSubject: "फ़ाइल विषय",
        EnterFileSubjectName: "फ़ाइल विषय नाम दर्ज करें ",
        FileSubjectName: "फ़ाइल का विषय नाम",
        ShortName: "संक्षिप्त नाम",
        FileType: "फ़ाइल प्रकार",
        EnterFileTypeName: "फ़ाइल प्रकार का नाम दर्ज करें",
        FileTypeName: "फ़ाइल प्रकार का नाम",
        SelectFileGroup: "फ़ाइल समूह का चयन करें",
        SelectFileCategory: "फ़ाइल श्रेणी का चयन करें",
        SelectFileType: "फ़ाइल प्रकार का चयन करें",
        SelectFileNo: "फ़ाइल संख्या का चयन करें",
        SelectFileClass: "फ़ाइल वर्ग का चयन करें",
        SelectFileSubject: "फ़ाइल विषय का चयन करें",
        ReceiptStatus: "रसीद की स्थिति",
        RecName: "रसीद का नाम",
        EnterRecName: "रसीद का नाम दर्ज करें",
        ReceiptType: "रसीद का प्रकार",
        ReceiptName: "रसीद का नाम",
        EnterReceiptName: "रसीद का नाम दर्ज करें",
        RecStatus: " रसीद की स्थिति",
        EnterRecStatus: "रसीद की स्थिति दर्ज करें",
        reqRecStatus: "रसीद की स्थिति आवश्यक है ",
        Location: "स्थान",
        LocationName: "स्थान का नाम",
        EnterLocationName: "स्थान का नाम दर्ज करें",
        LocationShortName: " स्थान संक्षिप्त नाम",
        EnterLocationShortName: "स्थान संक्षिप्त नाम दर्ज करें",
        senderID: "प्रेषक आईडी",
        receiverID: "रिसीवर आईडी",
        currentLocation: "वर्तमान स्थान",
        EnterSignatureUpload: "हस्ताक्षर संलग्न करें",
        EnterLocationObject: "स्थान ऑब्जेक्ट दर्ज करें",
        EnterAbbreviation: "संक्षिप्त नाम दर्ज करें",
        Abbreviation: "लघु रूप",
        LocationObject: "स्थान वस्तु",
        reqLocationObject: "स्थान ऑब्जेक्ट की आवश्यकता है ",
        reqFileGroupName: "फ़ाइल समूह नाम की आवश्यकता है",
        reqFileSubjectName: "फ़ाइल विषय नाम की आवश्यकता है",
        reqFileTypeName: "फ़ाइल प्रकार नाम आवश्यक है",
        reqReceiptName: "रसीद नाम की आवश्यकता है",
        EnterDocUpload: "दस्तावेज़ संलग्न करें",
        EnterDocSubType: "दस्तावेज़ विषय प्रकार",
        EnterSubDocAbbreviation: "दस्तावेज़ विषय संक्षिप्त नाम",
        SelectDoctype: "दस्तावेज़ प्रकार चुनें",
        SelectFileName: "फ़ाइल नाम चुनें",
        SelectSubject: "विषय चुनें",
        SelectDivision: "प्रभाग का चयन करें",
        EnterCountryShortName: "देश का संक्षिप्त नाम दर्ज करें",
        EnterStateShortName: "राज्य का संक्षिप्त नाम दर्ज करें",
        EnterdisplayNo: "डिस्प्ले नंबर दर्ज करें",
        SelectDocType: "दस्तावेज़ प्रकार का चयन करें",
        enterDesCode: "पदनाम कोड दर्ज करें",
        DesignationName: "पदनाम का नाम",
        DesignationCode: "पदनाम कोड",
        DocType: "दस्तावेज़ का प्रकार",
        DocSubType: "दस्तावेज़ उप प्रकार",
        CreateDocType: "दस्तावेज़ प्रकार बनाएँ",
        EditDocType: "दस्तावेज़ प्रकार संपादित करें",
        EnterDocType: "दस्तावेज़ प्रकार दर्ज करें",
        EntryDate: "प्रवेश की तारीख",
        EnterDocName: "दस्तावेज़ का नाम दर्ज करें",
        DocSubject: "दस्तावेज़ विषय",
        Subject: "विषय",
        DocSubSubject: "दस्तावेज़ उप विषय",
        SubSubject: "उप विषय",
        FileNo: "फ़ाइल संख्या",
        Synopsis: "रूपरेखा",
        FileDef: "फ़ाइल परिभाषा",
        DocumentEntry: "दस्तावेज़ प्रविष्टि",
        DocumentEntryAdd: "दस्तावेज़ प्रविष्टि जोड़ें",
        reqFileNo: "फ़ाइल नंबर की आवश्यकता है",
        EnterFileNo: "फ़ाइल संख्या दर्ज करें",
        EnterSynopsis: "सारांश दर्ज करें",
        EnterPartNo: "भाग संख्या दर्ज करें",
        EnterPeriodFileUpto: "तक पीरियड फाइल दर्ज करें",
        EnterSubject: "विषय दर्ज करें",
        EnterFileDef: " फ़ाइल परिभाषा दर्ज करें",
        EnterComplete: "पूर्ण दर्ज करें",
        EnterAuthenticatePerson: "प्रमाणित व्यक्ति दर्ज करें",
        EnterFileDate: "फ़ाइल दिनांक दर्ज करें",
        SelectFile: "फ़ाइल का चयन करें",
        SelectSubject: "विषय का चयन करें",
        SelectDivision: "डिवीजन का चयन करें",
        EnterPeriodDate: "अवधि तिथि दर्ज करें",
        AttachedFile: "अनुलग्न फ़ाइल",
        EnterFileName: "फ़ाइल नाम दर्ज करें",
        PeriodDate: "अवधि की तारीख",
        Keywords: "कीवर्ड",
        FileName: "फ़ाइल का नाम",
        PdfFile: "पीडीएफ",
        DocumentEntryEdit: "दस्तावेज़ प्रविष्टि संपादित करें",
        EnterKeyword: "कीवर्ड दर्ज करें",
        PdfName: "पीडीएफ नाम",
        DocFiles: "दस्तावेज़ फ़ाइलें",
        SelectDoc: "दस्तावेज़ का चयन करें",
        SelectLocation: "स्थान का चयन करें",
        reqPdfName: "पीडीएफ नाम की आवश्यकता है",
        CreateDocFiles: "दस्तावेज़ फ़ाइलें बनाएँ",
        EditDocFiles: "दस्तावेज़ फ़ाइलें संपादित करें",
        EnterPdfName: "पीडीएफ नाम दर्ज करें",
        EnterKeywords: "कीवर्ड दर्ज करें",
        EnterSubFtype: "उप फ़ाइल प्रकार दर्ज करें",
        EnterPdfDate: "पीडीएफ तिथि दर्ज करें",
        DocPages: "दस्तावेज़ पृष्ठ",
        Comments: "टिप्पणियाँ",
        PhysicalSerialNo: "भौतिक क्रम संख्या",
        PhysicalIndex: "भौतिक सूचकांक",
        CreateDocPages: "दस्तावेज़ पेज बनाएं",
        EditDocPages: "दस्तावेज़ पृष्ठ संपादित करें",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoUpto: "पृष्ठ क्रमांक तक",
        EnterComments: "टिप्पणियाँ दर्ज करें",
        EnterPhysicalSerialNo: "भौतिक सीरियल नंबर दर्ज करें",
        EnterPhysicalIndex: "भौतिक अनुक्रमणिका दर्ज करें",
        SelectField: "फ़ील्ड का चयन करें",
        DocViewer: "दस्तावेज़ व्यूअर",
        SubFileType: "उप फ़ाइल प्रकार",
        ViewPdf: "पीडीएफ देखें",
        View: "देखना",
        NoRecordAvailable: "कोई रिकॉर्ड उपलब्ध नहीं है",
        NoPdfAvailable: "कोई पीडीएफ उपलब्ध नहीं है",
        AddComment: "टिप्पणी जोडा",
        PageNoFrom: "पृष्ठ संख्या से",
        PageNoTo: "पृष्ठ संख्या को",
        RelatedOficer: "संबंधित अधिकारी",
        AddRow: "पंक्ति जोड़ें",
        Index: "सूचकांक!",
        SelectDevision: "प्रभाग का चयन करें",
        SelectFileStatus: "फ़ाइल स्थिति का चयन करें",
        DocumentIndexing: "दस्तावेज़ अनुक्रमण",
        Filter: "फ़िल्टर ",
        Print: "प्रिंट",
        PeriodFrom: "से अवधि",
        PeriodTo: "अवधि से",
        Search: "ढूँढ",
        Clear: "स्पष्ट",
        ViewIndexPdf: "इंडेक्स पीडीएफ देखें",
        ViewFullPdf: "पूरा पीडीएफ देखें",
        FileDefinition: "फ़ाइल परिभाषा",
        SearchKeywords: "खोज कीवर्ड",
        DateFrom: "तारीख से",
        DateTo: "करने के लिए तारीख",
        Complete: "पूरा",
        SplitPdfToJump: "जम्प के लिए पीडीएफ विभाजित करें",
        SplitPage: "विभाजित पृष्ठ",
        PdfFileName: "पीडीएफ फाइल का नाम",
        PageFrom: "पृष्ठ से",
        PageTo: "पृष्ठ तक",
        ViewFile: "फ़ाइल देखें",
        AddPdf: "पीडीएफ जोड़ें",
        DocUpload: "दस्तावेज़ अपलोड",
        EnterRemark: "टिप्पणी दर्ज करें",
        EnterValue: "मान दर्ज करें",
        FileSaved: "फ़ाइल सहेजी गई",
        EnterMainPdf: "मुख्य पीडीएफ दर्ज करें",
        EnterPdf: "पीडीएफ दर्ज करें",
        PdfMearge: "पीडीएफ मर्ज",
        SplitMainFile: "मुख्य फ़ाइल विभाजित करें",
        ForRename: "नाम बदलने के लिए",
        ForShiftCategory: "शिफ्ट श्रेणी के लिए",
        UpdatePdf: "पीडीएफ अपडेट करें",
        PdfCounter: "पीडीएफ काउंटर",
        EnterFolderPath: "फ़ोल्डर पथ दर्ज करें",
        Count: "गिनना",
        EmployeeEntry: "कर्मचारी प्रवेश",
        EmployeeName: "कर्मचारी का नाम",
        Login: "लॉगिन",
        Password: "पासवर्ड",
        Edit: "संपादित करें",
        delete: "मिटाना",
        Export: "निर्यात ",
        Release: "जारी ",
        Post: "पोस्ट ",
        SelectEmployeeName: "कर्मचारी का नाम चुनें",
        ParentName: "जनक नाम",
        EmployeeMaster: "कर्मचारी मास्टर",
        EmpName: "कर्मचारी का नाम",
        EmpCode: "कर्मचारी कोड",
        EmpStatus: "कर्मचारी की स्थिति",
        SelectState: "राज्य का चयन करें",
        SelectCountry: "देश का चयन करें",
        SelectDistrict: "जिले का चयन करें",
        reqEmpName: "कर्मचारी का नाम आवश्यक है",
        reqEmpCode: "कर्मचारी कोड की आवश्यकता है",
        reqFatherName: "पिता का नाम आवश्यक है",
        reqMobNo: "मोबाइल नंबर की आवश्यकता है",
        reqPanNo: "पैन नंबर की आवश्यकता है",
        reqJoiningDate: "ज्वाइनिंग डेट आवश्यक है",
        reqDesignation: "पदनाम की आवश्यकता है",
        reqDepartment: "विभाग की आवश्यकता है",
        reqPerAddress: "स्थायी पते की आवश्यकता है",
        reqPinCode: "पिन कोड की आवश्यकता है",
        reqAdharNo: "आधार नंबर की आवश्यकता है",
        reqEmail: "ईमेल की आवश्यकता है",
        reqEmpdob: "कर्मचारी जन्मतिथि आवश्यक है",
        CreateEmployeeReg: "कर्मचारी पंजीकरण बनाएँ",
        EditEmployeeReg: "कर्मचारी पंजीकरण संपादित करें",
        EnterEmpName: "कर्मचारी का नाम दर्ज करें",
        EnterEmpCode: "कर्मचारी कोड दर्ज करें",
        EnterFatherName: "पिता का नाम दर्ज करें",
        EnterSpauseName: "स्पाज़ नाम दर्ज करें",
        EnterMotherName: "माता का नाम दर्ज करें",
        EnterMobileNumber: "मोबाइल नंबर दर्ज करें",
        EnterEmail: "ईमेल दर्ज करें",
        EnterPanNo: "पैन नंबर दर्ज करें",
        EnterAdharNo: "आधार नंबर दर्ज करें",
        EnterDOB: "जन्म तिथि दर्ज करें",
        EnterJoiningDate: "ज्वाइनिंग डेट दर्ज करें",
        EnterRetirementDate: "सेवानिवृत्ति की तिथि दर्ज करें",
        EnterLocalAddress: "स्थानीय पता दर्ज करें",
        EnterPerAddress: "स्थायी पता दर्ज करें",
        EnterPinCode: "पिन कोड दर्ज करें",
        AttachedImage: "संलग्न छवि",
        DocManagerReport: "दस्तावेज़ प्रबंधक रिपोर्ट",
        SelectSubSubject: " उप विषय का चयन करें",
        SubSubjectName: "उप विषय का नाम",
        DivisionName: "डिवीजन का नाम",
        Remark: "टिप्‍पणी करना",
        SessionYear: "सत्र वर्ष",
        InActive: "निष्क्रिय",
        Active: "सक्रिय",
        TotalDoc: "कुल दस्तावेज़",
        TotalType: "कुल प्रकार",
        TotalIndexFile: "कुल अनुक्रमणिका फ़ाइल",
        TotalSplitFile: "कुल विभाजित फ़ाइल",
        Zone: "क्षेत्र",
        LineChart: "लाइन चार्ट",
        Department: "विभाग",
        AcademicDepartment: "शैक्षणिक विभाग",
        DocumentManagementSystem: "दस्तावेज़ प्रबंधन प्रणाली",
        PartNo: "भाग संख्या",
        PeriodFileNo: "अवधि फ़ाइल संख्या",
        AuthonticatedPerson: "प्रामाणिक व्यक्ति",
        FileDate: "फ़ाइल दिनांक",
        SubjectId: "विषय आईडी ",
        ToDate: "तारिख तक",
        MergeToIndexFile: "इंडेक्स  फ़ाइल में मर्ज करें",
        MergeToOriginalFile: "मूल फ़ाइल में मर्ज करें",
        DOB: "जन्म तिथि",
        Comment: "टिप्पणी",
        DocType: "दस्तावेज़ प्रकार",
        DocName: "दस्तावेज़ का नाम",
        DocCode: "दस्तावेज़ कोड",
        DocDescription: "दस्तावेज़ विवरण",
        DocStatus: "दस्तावेज़ निर्देश",
        DocIndexFile: "दस्तावेज़ अनुक",
        DocSplitFile: "दस्तावेज़ विभाजित",
        DocOriginalFile: "दस्तावेज़ मूल",
        DocIndexFileNo: "अनुक्रमणिका फ़ाइल संख्या",
        DocSplitFileNo: "विभाजित फ़ाइल संख्या",
        DocOriginalFileNo: "मूल फ़ाइल संख्या",
        DocIndexFileNo: "अनुक्रमणिका फ़ाइल संख्या",
        DocSplitFileNo: "विभाजित फ़ाइल संख्या",
        DocOriginalFileNo: "मूल फ़ाइल संख्या",
        DocIndexFileNo: "अनुक्रमणिका फ़ाइल संख्या",
        DocSplitFileNo: "विभाजित फ़ाइल संख्या",
        DocOriginalFileNo: "मूल फ़ाइल संख्या",
        DocIndexFileNo: "अनुक्रमणिका फ़ाइल संख्या",
        DocSplitFileNo: "विभाजित फ़ाइल",

        PageTitle: "पृष्ठ शीर्षक",
        FilterOptions: "फ़िल्टर विकल्प",
        SelectOrEnterFileNo: "फ़ाइल संख्या चुनें या दर्ज करें",
        LoadingData: "डेटा लोड हो रहा है...",
        FiltersCleared: "फ़िल्टर साफ़ किए गए",
        DownloadPDF: "PDF डाउनलोड करें",
        SelectFileType: "फ़ाइल प्रकार चुनें",
        EnterPeriodFileFrom: "फ़ाइल की प्रारंभ अवधि दर्ज करें",
        reqsubsubjId: "विषय आवश्यक है",
        reqdivisionid: "विभाग आवश्यक है",
        SelectPdf: "PDF चुनें",
        SplitFileView: "फ़ाइल दृश्य विभाजित करें",
        NoPDFPreviewAvailable: "कोई PDF पूर्वावलोकन उपलब्ध नहीं है",
        LoadingPDF: "PDF लोड हो रहा है",
        reqfileTypeID: "फ़ाइल प्रकार आवश्यक है",
        reqFileStatus: "फ़ाइल की स्थिति आवश्यक है",
        reqFileName: "फ़ाइल नाम आवश्यक है",
        reqFileCode: "फ़ाइल कोड आवश्यक है",
        reqFileDescription: "फ़ाइल विवरण आवश्यक है",
        reqFileStatus: "फ़ाइल की स्थिति आवश्यक है",
        reqFileDate: "फ़ाइल की दिनांक आवश्यक है",
        SelectedFileName: "चयनित फ़ाइल नाम",
        Attachments: "संलग्नक",
        Process: "प्रक्रिया",
        Pending: "लंबित",
        Complete: "पूर्ण",
        DocManagerReport: "दस्तावेज़ प्रबंधक रिपोर्ट",
        Filter: "फ़िल्टर",
        Print: "प्रिंट",
        Search: "खोज",
        Searching: "खोज रहे हैं",
        Clear: "साफ़ करें",
        NoDataFound: "कोई डेटा नहीं मिला",
        ErrorFetchingData: "डेटा प्राप्त करने में त्रुटि",
        NetworkError: "नेटवर्क त्रुटि हुई",
        ErrorFetchingFilters: "फ़िल्टर विकल्प प्राप्त करने में त्रुटि",
        FiltersCleared: "फ़िल्टर साफ़ किए गए",
        FilterOptions: "फ़िल्टर विकल्प",
        SelectDivision: "विभाग चुनें",
        SelectSubSubject: "उप विषय चुनें",
        SelectFileType: "फ़ाइल प्रकार चुनें",
        SelectOrEnterFileNo: "फ़ाइल नंबर चुनें या दर्ज करें",
        SelectStatus: "स्थिति चुनें",
        FromDate: "दिनांक से",
        ToDate: "दिनांक तक",
        SrNo: "क्र. सं.",
        FileName: "फ़ाइल नाम",
        Subject: "विषय",
        FileNo: "फ़ाइल नंबर",
        FileType: "फ़ाइल प्रकार",
        SubSubjectName: "उप विषय नाम",
        DivisionName: "विभाग नाम",
        Date: "तारीख",
        LoadingData: "डेटा लोड हो रहा है",
        NoReportsFound: "कोई रिपोर्ट नहीं मिली",
        NoMatchingResults: "कोई मेल खाता परिणाम नहीं मिला",
        Details: "विवरण",
        DocumentManager: "दस्तावेज़ प्रबंधक",
        PrintPreview: "मुद्रण पूर्वावलोकन",
        requestInProgress: "अनुरोध पहले से ही प्रगति पर है",
        tooManyRequests: "बहुत सारे अनुरोध। कृपया एक क्षण प्रतीक्षा करें",
        somethingWentWrong: "कुछ गलत हो गया। कृपया पुनः प्रयास करें",
        submitting: "जमा किया जा रहा है...",
        save: "सहेजें",
        reset: "रीसेट",
        CreateCountryName: "देश बनाएं",
        EnterCountryName: "देश का नाम दर्ज करें",
        EnterCountryShortName: "देश का संक्षिप्त नाम दर्ज करें",
        countryNameMaxLength: "देश का नाम 20 अक्षरों से अधिक नहीं हो सकता",
        countryShortNameMaxLength:
          "देश का संक्षिप्त नाम 10 अक्षरों से अधिक नहीं हो सकता",
        RoleUpdatedSuccess: "भूमिका सफलतापूर्वक अपडेट की गई",
        RoleAddedSuccess: "भूमिका सफलतापूर्वक जोड़ी गई",
        invalidCountryName:
          "देश का नाम केवल अक्षर, रिक्त स्थान और हाइफन contain कर सकता है",
        invalidCountryShortName:
          "देश का संक्षिप्त नाम केवल अक्षर और हाइफन contain कर सकता है",
        noSpecialCharsStartEnd:
          "देश का नाम विशेष वर्णों से शुरू या समाप्त नहीं हो सकता",
        noSpecialCharsStartEndShort:
          "संक्षिप्त नाम विशेष वर्णों से शुरू या समाप्त नहीं हो सकता",
        noMultipleSpecialChars:
          "देश का नाम में लगातार कई विशेष वर्ण नहीं हो सकते",
        passwordValidation:
          "पासवर्ड में कम से कम एक अपरकेस अक्षर, एक लोअरकेस अक्षर, एक अंक, एक विशेष वर्ण और न्यूनतम 8 अक्षर होने चाहिए।",
        subDeptMaster: "उप विभाग मास्टर",
        subDeptName: "उप विभाग का नाम",
        filterByDept: "विभाग से फ़िल्टर करें",
        allDepartments: "सभी विभाग",
        CreateSubDeptMaster: "उप विभाग बनाएं",
        EditSubDeptMaster: "उप विभाग संपादित करें",
        EnterSubDeptName: "उप विभाग का नाम दर्ज करें",
        SelectDepartment: "विभाग चुनें",
        reqDeptName: "विभाग का नाम आवश्यक है",
        reqSubDeptName: "उप विभाग का नाम आवश्यक है",
        invalidDepartmentSelection: "कृपया एक मान्य विभाग चुनें",
        invalidSubDeptName:
          "उप विभाग का नाम केवल अक्षर, संख्याएं, रिक्त स्थान, हाइफन, &, ., ,, (, ) हो सकते हैं",
        subDeptNameMaxLength: "उप विभाग का नाम 50 वर्णों से अधिक नहीं हो सकता",
        noSpecialCharsStartEnd: "विशेष वर्णों से शुरू या समाप्त नहीं हो सकता",
        noMultipleSpecialChars: "लगातार कई विशेष वर्ण नहीं हो सकते",
        failedToLoadDepartments: "विभाग लोड करने में विफल",
        badRequest: "अमान्य अनुरोध डेटा",
        selectOption: "एक विकल्प चुनें",
        submitting: "सबमिट किया जा रहा है...",
        save: "सहेजें",
        update: "अपडेट करें",
        reset: "रीसेट करें",
        requestInProgress: "अनुरोध प्रगति पर है, कृपया प्रतीक्षा करें...",
        tooManyRequests: "बहुत सारे अनुरोध, कृपया बाद में पुनः प्रयास करें",
        somethingWentWrong: "कुछ गलत हुआ, कृपया पुनः प्रयास करें",
        Action: "क्रिया",
        SrNo: "क्र.सं.",
        Status: "स्थिति",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        add: "जोड़ें",
        search: "खोजें",
        print: "प्रिंट करें",
        deptName: "विभाग का नाम",
        deptCode: "विभाग कोड",
        deptMaster: "विभाग मास्टर",
        SelectSubDept: "उपविभाग का चयन करें",
        newNodeMaster: "नया नोड मास्टर",
        addNewNode: "नया नोड जोड़ें",
        editNode: "नोड संपादित करें",
        nodeID: "नोड आईडी",
        nodeName: "नोड का नाम",
        enterNodeName: "नोड का नाम दर्ज करें",
        save: "सहेजें",
        update: "अपडेट करें",
        cancel: "रद्द करें",
        edit: "संपादित करें",
        delete: "हटाएं",
        nodeIDRequired: "नोड आईडी आवश्यक है",
        nodeIDMinValue: "नोड आईडी 0 या उससे अधिक होनी चाहिए",
        nodeNameRequired: "नोड का नाम आवश्यक है",
        nodeNameMaxLength: "नोड का नाम 100 अक्षरों से अधिक नहीं हो सकता",
        invalidNodeName:
          "अमान्य नोड नाम। केवल अक्षर, संख्याएं, रिक्त स्थान, हाइफन, &, ., ,, और () की अनुमति है",
        noSpecialCharsStartEnd:
          "नोड का नाम विशेष वर्णों से शुरू या समाप्त नहीं हो सकता",
        nodeAddedSuccessfully: "नोड सफलतापूर्वक जोड़ा गया",
        nodeUpdatedSuccessfully: "नोड सफलतापूर्वक अपडेट किया गया",
        nodeDeletedSuccessfully: "नोड सफलतापूर्वक हटाया गया",
        deleteConfirmation: "हटाने की पुष्टि",
        deleteConfirmationMessage: "क्या आप वाकई इस नोड को हटाना चाहते हैं?",
        deleteCancelled: "हटाना रद्द किया गया",
        operationFailed: "ऑपरेशन विफल",
        deleteFailed: "नोड हटाने में विफल",
        nodeNotFound: "नोड नहीं मिला",
        badRequest: "अमान्य अनुरोध",
        somethingWentWrong: "कुछ गड़बड़ हुई। कृपया पुनः प्रयास करें।",
        failedToLoadNodes: "नोड लोड करने में विफल",
        requestInProgress: "अनुरोध प्रगति पर है",
        tooManyRequests: "बहुत सारे अनुरोध। कृपया बाद में पुनः प्रयास करें।",
        Action: "क्रिया",
        SrNo: "क्र. सं.",
      },
      content: {},
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage || "en",
  // lng: 'hi',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
